export default __webpack_public_path__ + "static/01-3ea6af984cb71c4bc742114984e300ed.gif";